<template>
  <div class="menu hide-display px-2 px-md-3 px-lg-5 py-2">
    <div
      class="d-flex justify-content-end align-items-center menu-con"
      @click="showMenu"
    >
      <p class="faint-red-text mb-0">CLOSE</p>
      <div class="d-flex flex-column py-4 rb-con ml-2 menuBarX" ref="menuBarX">
        <span class="bar one" ref="one"></span>
        <span class="bar two" ref="two"></span>
      </div>
    </div>
    <div class="menu-con">
      <b-row>
        <b-col sm="12" md="6" lg="7" class="d-flex">
          <div
            class="social-links medium-font m-0 align-self-end"
            data-aos="fade-up"
            data-aos-duration="900"
          >
            <a href="https://twitter.com/daveaji" class="red-text ml-5 mr-4"
              >TWITTER</a
            >
            <span class="red-text">/</span>
            <a href="https://github.com/Ajiva-D" class="red-text mx-4"
              >GITHUB</a
            >
            <span class="red-text">/</span>
            <a href="https://instagram.com/ajiva_d" class="red-text ml-4"
              >INSTAGRAM</a
            >
          </div>
          <div data-aos="fade-right" data-aos-duration="2000">
            <ul class="pl-4">
              <li
                class="d-flex menu-link-item mt-4 mt-md-5"
                v-for="(item, index) in items"
                :key="index"
                @click="showMenu"
                v-scroll-to="`#${item.title}`"
              >
                <span>{{ item.id }}</span>
                <h1 class="ml-1 ml-md-4 mr-2 mr-md-5">{{ item.title }}</h1>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="25.197"
                  viewBox="0 0 25.342 25.197"
                  class="align-self-end mb-4"
                >
                  <g transform="translate(0 1.5)">
                    <path
                      d="M911.487,278.077h23.842v22.588"
                      transform="translate(-911.487 -278.077)"
                      fill="none"
                      stroke="#8d140e"
                      stroke-width="3"
                    />
                    <path
                      d="M936.329,277.077l-22.637,22.637"
                      transform="translate(-912.487 -277.077)"
                      fill="none"
                      stroke="#8d140e"
                      stroke-width="3"
                    />
                  </g>
                </svg>
              </li>
            </ul>
          </div>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="5"
          class="d-flex flex-column justify-content-end"
        >
          <div class="v-lottie-con">
            <Lottie
              :options="defaultOptions"
              :height="height"
              :width="width"
              v-on:animCreated="handleAnimation"
            />
          </div>
          <p class="red-text my-name">DAVID ENOCH AJI</p>
          <div
            class="d-flex mt-0 mt-md-5 pt-0 pt-md-5 justify-content-end align-self-end position-fixed bottom-0"
          >
            <a href="mailto:davidenochaji@gmail.com" class="mr-3 contact-text">
              <h3 class="cream-text pb-1">Contact Me</h3>
              <hr class="contact-bottom" />
            </a>
            <a href="mailto:davidenochaji@gmail.com">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="36"
                viewBox="0 0 66 36"
                class="message-icon"
              >
                <g fill="none" stroke="#8d140e" stroke-width="3" id="msg-g">
                  <rect width="66" height="36" stroke="none" />
                  <rect x="1.5" y="1.5" width="63" height="33" fill="none" />
                </g>
                <path
                  d="M1805.865,947.306l31.433,20.845,30.622-20.845"
                  transform="translate(-1803.81 -944.989)"
                  fill="none"
                  stroke="#8d140e"
                  stroke-width="3"
                  id="msg-r"
                />
              </svg>
            </a>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
// import Close from '../components/CloseX'
import Lottie from "vue-lottie";
import * as animationData from "../assets/lottie/aji_file.json";

export default {
  components: {
    Lottie
  },
  data() {
    return {
      defaultOptions: {
        animationData: animationData.default
      },
      animationSpeed: 1,
      height: 400,
      width: 400,
      items: [
        {
          id: "01",
          title: "Home",
          offset: -200
        },
        {
          id: "02",
          title: "About",
          offset: -1900
        },
        {
          id: "03",
          title: "Projects",
          offset: -200
        }
      ]
    };
  },
  methods: {
    showMenu() {
      let home = document.querySelector(".full-home");
      let menu = document.querySelector(".menu");
      let link = document.querySelectorAll(".menu-link-item");
      let body = document.querySelector("body");
      let menuBar = document.querySelector(".menuBar");
      let menuBarX = document.querySelector(".menuBarX");
      // this.$refs.menuBarX.classList.remove("rb-con");
      // this.$refs.menuBarX.classList.add("b-con");
      menuBar.classList.remove("rb-con");
      menuBar.classList.add("b-con");
      menuBarX.classList.remove("rb-con");
      menuBarX.classList.add("b-con");
      this.$store.commit("changeMenuState");
      menu.classList.remove("show-display", "slide-in");
      menu.classList.add("hide-display", "slide-out");
      home.classList.add("show-display");
      home.classList.remove("hide-display");
      for (let i = 0; i < link.length; i++) {
        link[i].classList.remove("text-slide");
      }
      body.style.height = "auto";
    },
    handleAnimation: function(anim) {
      this.anim = anim;
    }
  }
};
</script>

<style scoped>
.menu-con:hover p {
  color: #ffa176;
  transition: all 0.3s ease-in;
  cursor: default;
}
.menu-con:hover .bar {
  background-color: #ffa176;
  transition: all 0.3s ease-in;
  border-color: #ffa176;
}
.menu {
  overflow-y: hidden !important;
}
.text-slide {
  animation: text-slide 1s ease-out;
}
@keyframes text-slide {
  from {
    left: -600px;
  }
  to {
    left: 0;
  }
}
.slide-in {
  animation: slide-in 0.5s ease-out;
}
@keyframes slide-in {
  from {
    height: 0vh;
  }
  to {
    height: 100vh;
  }
}
.slide-out {
  animation: slide-out 0.5s ease-in;
}
@keyframes slide-out {
  from {
    height: 100vh;
  }
  to {
    height: 0px;
  }
}
.bar {
  background-color: #13120d;
  height: 2px;
  width: 40px;
  display: inline-block;
}
.rb-con .one {
  margin: 0px;
  transform: rotate(45deg);
  transition: all 0.5s ease-in-out;
  background-color: #8d140e;
}
.rb-con .two {
  transform: rotate(-45deg);
  transition: transform 0.5s ease-in-out;
  background-color: #8d140e;
}
.b-con .one,
.b-con .two {
  transform: rotate(0deg);
  transition: transform 0.5s ease-in-out;
}
/*  */
.menu {
  background-color: #c83402;
  height: 100vh;
}
.faint-red-text {
  color: #8d140e;
}
ul {
  list-style: none;
}
.social-links {
  writing-mode: vertical-lr;
  transform: rotate(-180deg);
  color: #71201c !important;
  /* height:20px; */
}
.social-links a:hover {
  color: #ffa176 !important;
}
.menuBarX .bar {
  transition: all 0.2s ease-in;
}
.menuBarX:hover ~ p {
  color: #ffa176 !important;
}
.menuBarX:hover .bar {
  background-color: #ffa176;
  /* transform: scale(1.5); */
  transition: all 0.5s ease-in;
  border-color: #ffa176;
}
.menuBarX:hover .one {
  transform: rotate(25deg);
}
.menuBarX:hover .two {
  transform: rotate(-25deg);
}
.message-icon:hover #msg-g,
.message-icon:hover #msg-r {
  stroke: #ffa176;
}
.message-icon {
  transition: all 0.2s ease-in;
}
.message-icon:hover {
  transform: scale(1.2);
  margin-bottom: 20px;
  transition: all 0.3s ease-in;
}
.menu-link-item {
  color: #71201c;
  padding-left: 0px;
  transition: all 0.5s ease-in-out;
  position: relative;
}
.menu-link-item:hover {
  color: #ffa176;
  cursor: pointer;
  padding-left: 100px;
  transition: all 1s ease-in-out;
}
.menu-link-item h1 {
  line-height: 0.9 !important;
  font-size: 7rem !important;
}
.code-img {
  width: 450px;
}
.contact-text:hover {
  cursor: default;
}
.contact-text:hover .contact-bottom {
  animation: line-slide 0.5s ease-in-out 2 alternate-reverse;
}
.contact-text h3 {
  transition: all 0.5s ease-in;
}
.contact-text:hover h3 {
  color: #71201c;
  transition: all 0.5s ease-in;
}
@keyframes line-slide {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
.contact-bottom {
  height: 2px;
  width: 100%;
  background-color: #ffa176;
  opacity: 1;
}
.my-name {
  position: absolute;
  right: 0;
  writing-mode: vertical-rl;
  transform: rotate(-180deg) translateY(-50%);
  bottom: 50%;
}
.bottom-0 {
  bottom: 100px;
}
@media only screen and (max-width: 768px) {
  .menu-link-item h1 {
    line-height: 0.9 !important;
    font-size: 5rem !important;
  }
  .social-links {
    position: absolute;
    bottom: -40vh;
    /* width: 500px; */
  }
  .code-img {
    width: 350px;
  }
  .menu {
    overflow-y: scroll !important;
  }
  .v-lottie-con {
    height: 310px;
  }
  .contact-text,
  .message-icon {
    position: relative;
    z-index: 20;
  }
  .bottom-0 {
    bottom: 0px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 999px) {
  .menu-link-item h1 {
    line-height: 0.9 !important;
    font-size: 5rem !important;
  }
  .code-img {
    width: 350px;
  }
}
@media only screen and (min-width: 2000px) {
  .menu-con {
    max-width: 1140px;
    margin: auto;
  }
}
</style>
